import {
  FETCH_PROFILE_API_BEGIN,
  FETCH_PROFILE_API_SUCCESS,
  FETCH_PROFILE_API_FAILURE,
  GENERIC_ERROR_MESSAGE
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const fetchProfileAPI = () => async dispatch => {
  dispatch({ type: FETCH_PROFILE_API_BEGIN });

  try {
    const response = await API({
      method: "POST",
      url: ENDPOINTS.FETCH_PROFILE
    });
    if(window.reactGlobals.isAllMdnDisconnected){
      if (response && response.data && response.data.hasOwnProperty("mtnDetailsOrig")) {
        dispatch({
          type: FETCH_PROFILE_API_SUCCESS,
          payload: response.data.mtnDetailsOrig
        });
      } else {
        dispatch({ type: FETCH_PROFILE_API_FAILURE });
      }
    }else{
      if (response && response.data && response.data.hasOwnProperty("mtnDetails")) {
        dispatch({
          type: FETCH_PROFILE_API_SUCCESS,
          payload: response.data.mtnDetails
        });
      } else {
        dispatch({ type: FETCH_PROFILE_API_FAILURE });
      }
  }
  } catch (error) {
    dispatch({
      type: FETCH_PROFILE_API_FAILURE,
      payload: error.response.description || GENERIC_ERROR_MESSAGE
    });
  }
};
